export default "__VITE_ASSET__BQ9A55Q7__"